<template>
  <div class="admin__home">
    <Header />
    <div class="admin__home--left-div">
      <Sidebar :item="item" />
    </div>
    <div class="admin__home--right-div">
      <div class="benefit">
        <p>
          <span class="benefit__back">
            <routerLink to="/benefits">Benefits</routerLink>
          </span> >
          <span class="benefit__current">HMO Summary</span>
        </p>
        <div class="benefit__header">
          <div class="benefit__header--text">HMO Summary</div>
          <div class="benefit__header--edit" v-if="manager !== 1">
            <div @click="showCreatePlan">
              <font-awesome-icon icon="plus" />&nbsp;Create New Plan
            </div>
          </div>
        </div>

        <div class="page-loader" v-show="pageLoading">
          <div>
            <PageLoader />
          </div>
        </div>

        <div class="benefit__body" v-show="!pageLoading">
          <div>
            <div class="error" v-show="dataFetchError">
              <p>Unable to fetch hmo data. Please try again.</p>
            </div>
          </div>

          <div class="benefit__div--content-body">
            <div class="benefit__div--content-body-details">
              <div>
                <div class="benefit__div--content-body-details-left">
                  <!-- <div>
                    <img :src="hmo.logo" />
                  </div>-->
                  <h5>{{hmo.provider}}</h5>
                </div>
                <div class="benefit__div--content-body-details-middle">
                  <div>
                    <span>Office Address:</span>
                    <p>{{hmo.office_address}}</p>
                  </div>
                  <div>
                    <span>Email Address:</span>
                    <p>{{hmo.email}}</p>
                  </div>
                  <div>
                    <span>Website:</span>
                    <p>{{hmo.website}}</p>
                  </div>
                </div>
                <div class="benefit__div--content-body-details-right">
                  <div>
                    <span>Contact Person</span>
                    <p class="name">{{hmo.contact_person}}</p>
                  </div>
                  <div>
                    <span>Phone Number</span>
                    <p>{{hmo.phone_1}}</p>
                  </div>
                  <div>
                    <span>Alternate Phone Number</span>
                    <p>{{hmo.phone_2}}</p>
                  </div>
                </div>
              </div>

              <!-- plans -->
              <div>
                <div class="benefit__div--content-body-plans">
                  <p>Plan Types</p>
                  <div>
                    <div v-for="(plan, index) in hmo.plans" :key="index">
                      <div>
                        <h6>{{plan.name}}</h6>
                        <p>Price: ₦{{ plan.price ? plan.price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : "0.00" }}</p>
                        <span @click="showEditPlan(plan)" v-if="manager !== 1">Edit Plan</span>
                        <div>
                          <a :href="` //${plan.details}`" target="_blank">
                            <div>View Plan Cover</div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <EditPlans v-if="editPlan" :plan="planToEdit" :hmo="hmo" @closeEditPlan="closeEditPlan" />
    <CreatePlans :hmo="hmo" v-show="createPlan" @closeCreatePlan="closeCreatePlan" />
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";

import CreatePlans from "./createPlan";
import EditPlans from "./editPlan";
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";

export default {
  name: "HmoSummary",
  components: {
    Header,
    Sidebar,
    EditPlans,
    CreatePlans,
    PageLoader
  },
  data() {
    return {
      item: "benefit",
      editPlan: false,
      createPlan: false,

      hmo: {},
      planToEdit: {},
      dataFetchError: false,

      pageLoading: true,
      manager: 1
    };
  },

  created() {
    this.getHmo();
    this.getManagerLevel();
  },

  methods: {
    getManagerLevel() {
      if (!this.$store.state.managedClient) {
        const companyId = this.$store.getters.currentAuthUser.employees
          .company_id;
        this.$http.get(`${types.COMPANY_GET_API}/${companyId}`).then(resp => {
          this.$store.state.managedClient = resp.data.data.managed;
          this.manager = this.$store.state.managedClient;
        });
      } else {
        this.manager = this.$store.state.managedClient;
      }
    },
    showEditPlan(plan) {
      this.planToEdit = plan;
      this.planToEdit.price = this.planToEdit.price
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      this.createPlan = false;
      this.editPlan = true;
    },
    closeEditPlan(reloadData = false) {
      if (reloadData) {
        this.getHmo();
      }
      this.createPlan = false;
      this.editPlan = false;
    },
    showCreatePlan() {
      this.editPlan = false;
      this.createPlan = true;
    },
    closeCreatePlan(reloadData = false) {
      if (reloadData) {
        this.getHmo();
      }
      this.editPlan = false;
      this.createPlan = false;
    },
    getHmo() {
      this.$http
        .get(`${types.GET_HMOS_API}/${this.$route.params.id}`)
        .then(resp => {
          const data = resp.data.data;
          this.hmo = data;
          this.pageLoading = false;
        })
        .catch(err => {
          this.pageLoading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.benefit {
  padding-top: 56px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;

  .page-loader {
    margin-top: 100px;

    > div {
      width: 55px;
      margin: auto;
    }
  }

  .error {
    margin-top: 10px;
    margin-bottom: 40px;
    text-align: left;
    color: red;
    font-size: 0.938vw;
    font-style: italic;
    p {
      margin: 0;
      padding-bottom: 10px;
    }
    p::first-letter {
      text-transform: uppercase;
    }
  }

  > p {
    font-size: 0.938vw;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;

    > .benefit__back {
      a {
        color: #5099de;
        text-decoration: none;
        cursor: pointer;
      }
    }

    > .benefit__current {
      color: #707070;
    }
  }

  .benefit__header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    align-content: center;
    margin-bottom: 5px;

    > .benefit__header--text {
      width: 327px;
      font-size: 2.083vw;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.18;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      margin: 0;
    }

    > .benefit__header--edit {
      width: 200px;

      > div {
        width: 9.063vw;
        height: 38px;
        float: right;
        border-radius: 2px;
        color: #fff;
        background-color: #5099de;
        font-size: 0.781vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: left;
        overflow: hidden;
        height: 38px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;

        > a {
          color: #ffffff;
          text-decoration: none;
          > div {
            height: 38px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
          }
        }
      }
    }
  }

  > .benefit__body {
    border-top: 1px solid #caced5;
    padding: 0 5px;

    > .benefit__div--content-body {
      > .benefit__div--content-body-details {
        padding: 40px 20px;
        border-radius: 2px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        background-color: #ffffff;
        margin: 50px 0;

        > div {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: flex-start;
          justify-content: center;
          align-content: center;

          > .benefit__div--content-body-details-left {
            width: 20%;
            > h5 {
              text-transform: capitalize;
            }

            > div {
              padding-right: 20px;
              max-width: 150px;
            }

            > p {
              font-size: 1.458vw;
              font-weight: 500;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.43;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
              margin-top: 20px;
            }
          }

          > .benefit__div--content-body-details-middle {
            width: 40%;

            > div {
              > span {
                font-size: 1.042vw;
                font-weight: 600;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
              }

              > p {
                font-size: 1.042vw;
                font-weight: 200;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
                margin-bottom: 15px;
                max-width: 26.667vw;
              }
            }
          }

          > .benefit__div--content-body-details-right {
            width: 40%;
            padding-left: 5.208vw;

            .name {
              text-transform: capitalize;
            }

            > div {
              > span {
                font-size: 1.042vw;
                font-weight: 600;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
              }

              > p {
                font-size: 1.042vw;
                font-weight: 200;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
                margin-bottom: 15px;
                max-width: 26.667vw;
              }
            }
          }

          > .benefit__div--content-body-plans {
            width: 100%;
            margin: 50px 0 20px 0;

            > p {
              font-size: 1.25vw;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.25;
              letter-spacing: normal;
              text-align: center;
              color: #f17d6b;
              text-decoration: underline;
            }

            > div {
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;
              margin-top: 30px;

              > div {
                padding: 0 20px;
                width: 33.33333333%;

                > div {
                  border-radius: 2px;
                  border: solid 1px #5099de;
                  background-color: rgba(80, 153, 222, 0.2);
                  padding: 30px;
                  text-align: center;

                  > h6 {
                    font-size: 0.938vw;
                    font-weight: normal;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.67;
                    letter-spacing: 0.54px;
                    text-align: center;
                    color: #000000;
                  }

                  > p {
                    font-size: 1.25vw;
                    font-weight: 600;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.25;
                    letter-spacing: 0.72px;
                    text-align: center;
                    color: #000000;
                  }

                  > span {
                    font-size: 0.729vw;
                    font-weight: 500;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 2.14;
                    letter-spacing: 0.42px;
                    text-align: left;
                    color: #f3826c;
                    cursor: pointer;
                  }

                  > div {
                    width: 8.594vw;
                    height: 38px;
                    margin: auto;
                    border-radius: 2px;
                    border: solid 1px #5099de;
                    background-color: #5099de;
                    margin-top: 40px;
                    overflow: hidden;

                    > a {
                      text-decoration: none;
                      color: #ffffff;

                      > div {
                        font-size: 0.938vw;
                        font-weight: normal;
                        font-style: normal;
                        font-stretch: normal;
                        line-height: 1.11;
                        letter-spacing: normal;
                        text-align: center;
                        color: #ffffff;
                        height: 38px;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        align-items: center;
                        justify-content: center;
                        align-content: center;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      > .benefit__div--content-body-enrol {
        margin-bottom: 50px;
        > p {
          font-size: 1.458vw;
          font-weight: 500;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.43;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          text-decoration: underline;
        }

        .benefit__div--content-body-enrol-filter {
          overflow: hidden;
          > .benefit__div--content-body-filter-left {
            width: 120px;
            height: 35px;
            border-radius: 2px;
            border: solid 1px #caced5;
            background-color: #ffffff;
            float: left;
            margin-right: 20px;
            font-size: 0.833vw;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.19;
            letter-spacing: normal;
            text-align: left;
            color: #777777;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
          }

          > .benefit__div--content-body-filter-right {
            width: 200px;
            height: 35px;
            border-radius: 2px;
            background-color: #ffffff;
            float: left;
          }
        }

        > .benefit__div--content-body-enrol-table {
          margin-top: 30px;
          > .benefit__div--content-body-table-header {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;

            > div {
              width: 33.33333333%;
              text-align: center;
              font-size: 1.042vw;
              font-weight: 500;
              font-style: normal;
              font-stretch: normal;
              line-height: 1;
              letter-spacing: normal;
              color: #000000;
            }
          }

          .benefit__div--content-body-table-body {
            border-top: 5px solid #5099de;
            margin-top: 20px;

            > div {
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;
              height: 76px;
              margin-bottom: 20px;
              background-color: #ffffff;
              border-radius: 2px;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

              > div {
                width: 33.33333333%;
                text-align: center;
                font-size: 1.042vw;
                font-weight: 500;
                font-style: normal;
                font-stretch: normal;
                line-height: 1;
                letter-spacing: normal;
                color: #000000;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;
                align-content: center;
              }
            }
          }
        }
      }

      > .benefit__div--content-body-paginate {
        border: 1px solid red;
        width: 20.833vw;
        margin: auto;
        height: 40px;
        border-radius: 4px;
        box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
        border: solid 1px #d7dae2;
        background-color: #ffffff;
        margin-bottom: 150px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;

        > .benefit__div--content-body-paginate-prev {
          width: 20%;
          font-size: 0.781vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.67;
          letter-spacing: normal;
          text-align: center;
          color: #5099de;
          height: 40px;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          cursor: pointer;
        }

        > .benefit__div--content-body-paginate-page {
          width: 60%;
          font-size: 0.781vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.67;
          letter-spacing: normal;
          text-align: center;
          color: #000;
          height: 40px;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          cursor: pointer;

          > div {
            width: 20%;
            height: 40px;
            border: solid 1px #d7dae2;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
          }
        }

        > .benefit__div--content-body-paginate-next {
          width: 20%;
          font-size: 0.781vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.67;
          letter-spacing: normal;
          text-align: center;
          color: #000;
          height: 52px;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
